module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTY3MiAzMmE2NCA2NCAwIDAgMSA2NCA2NHY4MS45YTY0IDY0IDAgMCAxLTQzLjggNjAuN0w2NDAgMjU2bDMyIDI4OCAxMDguNSAyMS43QTY0IDY0IDAgMCAxIDgzMiA2MjguNVY3MzZhNjQgNjQgMCAwIDEtNjQgNjRoLTIyNHYxOTJhMzIgMzIgMCAwIDEtNjQgMHYtMTkySDI1NmE2NCA2NCAwIDAgMS02NC02NHYtMTA3LjVhNjQgNjQgMCAwIDEgNTEuNS02Mi44TDM1MiA1NDRsMzItMjg4LTUyLjItMTcuNEE2NCA2NCAwIDAgMSAyODggMTc3LjlWOTZhNjQgNjQgMCAwIDEgNjQtNjRoMzIweiIgZmlsbD0iIzAiIHAtaWQ9IjM3MzMiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Fixed-filled.svg
// module id = /kbD
// module chunks = 74